import { type ReactNode, type SVGAttributes } from 'react';
import { CgWorkAlt } from 'react-icons/cg';

export interface IconBaseProps extends SVGAttributes<SVGElement> {
  children?: ReactNode;
  size?: string | number;
  color?: string;
  title?: string;
}
export type IconType = (props: IconBaseProps) => ReactNode;
interface ResumeJob {
  id: string;
  company: string;
  position: string;
  location?: string;
  title?: string;
  startDate: string; // Use ISO 8601 date format (e.g., "2023-01-01")
  endDate?: string; // Optional, for current job
  tasks: string[]; // Each string contains an impact / description
}

export interface RenderResumeJob extends ResumeJob {
  Icon?: IconType;
  /**
   * startDate - endDate
   */
  date?: string;
}

const AMAZON_JOB_2: ResumeJob = {
  id: 'amzn2',
  company: 'Amazon',
  position: 'SDE II',
  startDate: 'May 2022',
  location: 'Seattle, WA',
  endDate: 'Present',
  tasks: [
    'Lead on release of greenfield project with positive feedback and adoption from 8k+ Fulfillment Center engineers',
    'Leadership experience mentoring 12 devs in DevOps, AWS, and React.js . 8 L4 Engineers, 4 Interns. Regularly consulted on critical internal typescript & python libraries.',
    'Responsible for team UI / UX. New designs increased sponsorship from 1 internal organization to 10+.',
    'Migrated team’s infrastructure to AWS / CDK. Moved team’s jobs and backend to Lambda/ECS computes.',
  ],
};

const AMAZON_JOB_1: ResumeJob = {
  id: 'amzn1',
  company: 'Amazon',
  position: 'SDE I',
  startDate: 'August 2020',
  location: 'Seattle, WA',
  endDate: 'May 2022',
  tasks: [
    'Moved team’s frontend to AWS / CloudFront. Website loaded 6x faster than previous CDN solution.',
    'Created data heavy charts and pivot tables with D3.js, SVG and React. Rendered over 9k elements.',
    'Setup GraphQL Client. Introduced browser cache which removed 66% duplicate request, improved UX.',
    'Deployed Boto3 and PyGreSQL Python scripts that batch processed metrics for 2k+ CI / CD pipelines.',
  ],
};

const APPLIED_CONCEPTS_JOB: ResumeJob = {
  id: 'appliedConcepts',
  company: 'Applied Concepts',
  position: 'JR Software Engineer',
  location: 'Tampa, FL',
  startDate: 'February 2020',
  endDate: 'August 2020',
  tasks: [
    'Replaced an old CRM used by sales team with a VueJS web application. Saved 1k in monthly licensing fees.',
    'Implemented a Spring Boot CRUD API for MySQL DB.',
  ],
};

const INTERNSHIP_JOB: ResumeJob = {
  id: 'bensonIntern',
  company: 'Benson Dental',
  position: 'Web Developer Intern',
  location: 'Houston, TX',
  startDate: 'Jan 2018',
  endDate: 'August 2020',
  tasks: [
    'Built a dental website with jQuery and TailwindCSS resulting in 30% increase of patient bookings.',
    'Created form with 3rd party appointment integration, lead to reduction in admin effort.',
  ],
};

export const JOB_HISTORY = [
  AMAZON_JOB_2,
  AMAZON_JOB_1,
  APPLIED_CONCEPTS_JOB,
  INTERNSHIP_JOB,
];

export const JOB_HISTORY_RENDER_DATA: RenderResumeJob[] = JOB_HISTORY.map(
  (job) => ({
    ...job,
    date: `${job.startDate} - ${job.endDate ?? 'Present'}`,
    title: job.position,
    Icon: CgWorkAlt,
  }),
);
